module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/re-7e8577e98f035e765e59bb047a0cd2d2.svg";